// extracted by mini-css-extract-plugin
export default {"secondaryHeader":"article_secondaryHeader__SxR+8","date":"article_date__1bAQm","newspage":"article_newspage__TnF07","path":"article_path__pOhnl"};